import { token } from '@cp/shared/di';
import { ClientSelection } from 'src/entities/client';
import { AsyncResult } from '@youhelp-ru/core';
import { CatalogItemStorageService } from './model';

type AuthFeature = (clientSelection?: ClientSelection) => AsyncResult<unknown, Error>;

export const CATALOG_ITEM_AUTH_FEATURE = token<AuthFeature>('catalogItem/AUTH_FEATURE');
export const CATALOG_ITEM_STORAGE_SERVICE = token<CatalogItemStorageService>('catalogItem/STORAGE_SERVICE');
